
<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import Cinnamomum_burmannii from "@/assets/pic/Cinnamomum_burmannii.jpg";
import Cinnamomum_camphora from "@/assets/pic/Cinnamomum_camphora.jpg";
import Cinnamomum_chago from "@/assets/pic/Cinnamomum_chago.jpg";
import Cinnamomum_kanehirae from "@/assets/pic/Cinnamomum_kanehirae.jpg";
import Cinnamomum_parthenoxylon from "@/assets/pic/Cinnamomum_parthenoxylon.jpg";
import Cinnamomum_verum from "@/assets/pic/Cinnamomum_verum.jpg";
import Laurus_nobilis from "@/assets/pic/Laurus_nobilis.jpg";
import Lindera_glauca from "@/assets/pic/Lindera_glauca.jpg";
import Litsea_cubeba from "@/assets/pic/Litsea_cubeba.jpg";
const pic=[Cinnamomum_burmannii,Cinnamomum_camphora,Cinnamomum_chago,Cinnamomum_kanehirae,Cinnamomum_parthenoxylon,Cinnamomum_verum,
Laurus_nobilis,Lindera_glauca,Litsea_cubeba]
</script>
<template>
  <div>
    <index-navbar/>
    <section
        class="header relative pt-16 items-center flex h-screen max-h-860-px"
    >
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="pt-32 sm:pt-0">
            <h2 class="font-semibold text-4xl text-blueGray-600">
              Cinnamomum Plants
            </h2>
            <p class="mt-4 text-lg leading-relaxed text-blueGray-500" style="text-align: justify">
              The <i>Cinnamomum</i> plants database collects and processes genome and transcriptome of
              <i>Cinnamomum</i> plants from existing databases. The database allows blast search, sequence browsing,
              downloading, etc. The database contains conserved motif analysis, phylogenetic tree analysis, functional
              annotation analysis, protein 3D structure analysis, differential expression analysis, etc. for terpene
              synthases of <i>Cinnamomum</i> plants.
              The database will be updated regularly to collect the latest sequenced genome and transcriptome of <i>Cinnamomum</i>
              plants, and new analysis tools will be added continuously.
            </p>
            <div class="mt-12">
              <router-link
                  to="/gene_expression"
                  class="get-started text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-emerald-500 active:bg-emerald-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
              >
                Get started
              </router-link>
              <router-link
                  to="/blast"
                  class="github-star ml-1 text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-blueGray-700 active:bg-blueGray-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Blast&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </router-link>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-6/12 px-4">
        <el-carousel :interval="3000"  type="card">
        <el-carousel-item v-for="item in pic" :key="item">
           <img :src="item">
        </el-carousel-item>
      </el-carousel>
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
